import { defineStore } from 'pinia'
import LocalStore from './local'
import Obra from '../services/model/obra'
import ObraLocalizacao from '@/services/model/obra-localizacao'
import { toRaw } from 'vue'

const obraStoreName = 'Obra'
const obraStorage = new LocalStore<Array<Obra>>(obraStoreName)
const obrasFiltradasStoreName = 'ObrasFiltradas'
const obrasFiltradasStorage = new LocalStore<Array<Obra>>(obrasFiltradasStoreName)
const subFiltrosStoreName = 'Subfiltros'
const subFiltroStorage = new LocalStore<any>(subFiltrosStoreName);

export const useObraStore = defineStore(obraStoreName, {
  // state
  state() {
    let obras = new Array<Obra>()
    let obrasFiltradas = new Array<Obra>()
    let obrasFiltradasOrdenadas = new Array<Obra>()

    const obraStorageData = obraStorage.getData()
    if (obraStorageData != null) {
      obras = obraStorageData
    }

    const obrasFiltradasStorageData = obrasFiltradasStorage.getData()
    if (obrasFiltradasStorageData != null) {
      obrasFiltradas = obrasFiltradasStorageData
      obrasFiltradasOrdenadas = obrasFiltradasStorageData
    }

    let statusBusca = ['vermelho', 'amarelo', 'verde'];
    let favoritos = false;
    const subfiltrosData = subFiltroStorage.getData();
    if (subfiltrosData != null) {
      statusBusca = subfiltrosData.statusBusca || statusBusca;
      favoritos = subfiltrosData.favoritos || favoritos;
    } else {
      subFiltroStorage.setData({ statusBusca, favoritos });
    }

    return {
      obras,
      obrasFiltradas,
      obrasFiltradasOrdenadas,
      obraSelecionada: null as null | Obra,
      obrasSelecionadas: new Array<Obra>(),
      obrasSelecionadasFiltradas: new Array<Obra>(),
      obrasSelecionadasFiltradasOrdenadas: new Array<Obra>(),
      textoBusca: '',
      statusBusca: statusBusca,
      ordenacaoCampo: '',
      ordenacaoDirecao: 'asc',
      favoritos: favoritos,
      listarObrasSelecionadas: false
    }
  },
  getters: {
    localizacoesFiltradas(): Array<ObraLocalizacao> {
      const resultadoFiltro = new Array<ObraLocalizacao>()

      for (const obra of this.obrasFiltradas) {
        for (const localizacao of obra.localizacoes) {
          const localizacaoDeepClone = new ObraLocalizacao(JSON.parse(JSON.stringify(localizacao)))
          localizacaoDeepClone.obra = new Obra(JSON.parse(JSON.stringify(obra)))
          resultadoFiltro.push(localizacaoDeepClone)
        }
      }

      return resultadoFiltro
    },
    quantidadeLocalizacoesSelecionadas(): number {
      //O objeto 'obras selecionadas' possui/representa somente uma localização por registro, portanto:
      return this.obrasSelecionadasFiltradas.length;
    }
  },
  actions: {
    filtrar(texto: string) {
      this.textoBusca = texto
      if (!this.listarObrasSelecionadas)
        this.filtrarOrdenarGeral()
      else
        this.filtrarOrdenarObrasSelecionadas();
    },
    filtrarPorStatus(status: string) {
      console.log('this.statusBusca', this.statusBusca)
      if (this.statusBusca.indexOf(status) === -1) {
        window.console.log('filtrando por status: ' + status)
        this.statusBusca.push(status)
      } else {
        window.console.log('removendo filtro por status: ' + status)
        this.statusBusca.splice(this.statusBusca.indexOf(status), 1)
      }

      let subFiltroStorageData = subFiltroStorage.getData() || {};
      subFiltroStorageData.statusBusca = this.statusBusca;
      subFiltroStorage.setData(subFiltroStorageData);

      if (!this.listarObrasSelecionadas)
        this.filtrarOrdenarGeral()
      else
        this.filtrarOrdenarObrasSelecionadas();
    },
    filtrarPorFavoritos(favoritar: boolean) {
      this.favoritos = favoritar

      let subFiltroStorageData = subFiltroStorage.getData() || {};
      subFiltroStorageData.favoritos = this.favoritos;
      subFiltroStorage.setData(subFiltroStorageData);

      if (!this.listarObrasSelecionadas)
        this.filtrarOrdenarGeral()
      else
        this.filtrarOrdenarObrasSelecionadas();
    },
    ordenar(ordenacaoCampo: keyof Obra) {
      this.ordenacaoCampo = ordenacaoCampo
      if (!this.listarObrasSelecionadas)
        this.filtrarOrdenarGeral()
      else
        this.filtrarOrdenarObrasSelecionadas();
    },
    alternarOrdenacao() {
      this.ordenacaoDirecao = this.ordenacaoDirecao == 'asc' ? 'desc' : 'asc'
      if (!this.listarObrasSelecionadas)
        this.filtrarOrdenarGeral()
      else
        this.filtrarOrdenarObrasSelecionadas();
    },
    filtrarOrdenarGeral() {
      const obraStorageData = obraStorage.getData()
      if (obraStorageData != null) {
        this.obras = obraStorageData
      }

      let resultadoFiltro = toRaw(this.obras) as Array<Obra>
      if (this.textoBusca.trim() != '') {
        resultadoFiltro = resultadoFiltro.filter(
          (obra) => gerarToken(obra).includes(this.textoBusca.trim().toLocaleLowerCase()),
          this
        )
      }

      resultadoFiltro = resultadoFiltro.filter((obra) => this.statusBusca.includes(obra.status))

      if (this.favoritos) {
        resultadoFiltro = resultadoFiltro.filter((obra) => obra.favorito)
      }

      this.obrasFiltradas = resultadoFiltro
      obrasFiltradasStorage.setData(resultadoFiltro)

      // para evitar looping infinito de watchers ou reactives?
      const obrasFiltradasCopy = toRaw(this.obrasFiltradas) as Array<Obra>

      obrasFiltradasCopy.sort((element1: Obra, element2: Obra) => { return ordenar(element1, element2, this.ordenacaoCampo, this.ordenacaoDirecao) })

      this.obrasFiltradasOrdenadas = obrasFiltradasCopy;
    },
    filtrarOrdenarObrasSelecionadas() {
      let resultadoFiltroObrasSelecionadas = toRaw(this.obrasSelecionadas) as Array<Obra>
      if (this.textoBusca.trim() != '') {
        resultadoFiltroObrasSelecionadas = resultadoFiltroObrasSelecionadas.filter(
          (obra) => gerarToken(obra).includes(this.textoBusca.trim().toLocaleLowerCase()),
          this
        )
      }

      resultadoFiltroObrasSelecionadas = resultadoFiltroObrasSelecionadas.filter((obra) => this.statusBusca.includes(obra.status))

      if (this.favoritos) {
        resultadoFiltroObrasSelecionadas = resultadoFiltroObrasSelecionadas.filter((obra) => obra.favorito)
      }

      this.obrasSelecionadasFiltradas = resultadoFiltroObrasSelecionadas;

      // para evitar looping infinito de watchers ou reactives?
      const obrasSelecionadasFiltradasCopy = toRaw(this.obrasSelecionadasFiltradas) as Array<Obra>
      obrasSelecionadasFiltradasCopy.sort((element1: Obra, element2: Obra) => { return ordenar(element1, element2, this.ordenacaoCampo, this.ordenacaoDirecao) })

      this.obrasSelecionadasFiltradasOrdenadas = obrasSelecionadasFiltradasCopy;
    },
    favoritar(obra: Obra) {
      const obraEncontradaIndex = this.obras.findIndex((p) => p.codLote == obra.codLote);
      if (obraEncontradaIndex > -1) {
        this.obras[obraEncontradaIndex].favorito = true;
        if (this.obras[obraEncontradaIndex] !== obra) {
          obra.favorito = true;
        }
      }
      else {
        obra.favorito = true;
        this.obras.push(obra);
      }

      obraStorage.setData(this.obras)
    },
    desfavoritar(obra: Obra) {
      const obraEncontradaIndex = this.obras.findIndex((p) => p.codLote == obra.codLote)
      if (obraEncontradaIndex > -1) {
        this.obras[obraEncontradaIndex].favorito = false
        if (this.obras[obraEncontradaIndex] !== obra) {
          obra.favorito = false;
        }
        obraStorage.setData(this.obras)
      } else {
        obra.favorito = true;
      }
    },
    update(obras: Array<Obra>) {
      this.textoBusca = ''
      this.ordenacaoCampo = ''
      this.statusBusca = ['vermelho', 'amarelo', 'verde']
      this.ordenacaoDirecao = 'asc'
      this.favoritos = false
      this.limparSelecoes()

      this.obras = obras
      this.obrasFiltradas = obras
      this.obrasFiltradasOrdenadas = obras
      obraStorage.setData(obras)
      obrasFiltradasStorage.setData(obras)
      subFiltroStorage.setData({ statusBusca: this.statusBusca, favoritos: this.favoritos })
    },
    selecionar(obra: Obra) {
      if (this.obraSelecionada != null && this.obraSelecionada.codLote == obra.codLote) {
        this.obraSelecionada = null
      } else {
        this.obraSelecionada = obra
      }
    },
    selecionarObrasNumMesmoPonto(localizacoes: Array<ObraLocalizacao>) {
      this.obrasSelecionadas = new Array<Obra>()
      for (const localizacao of localizacoes) {
        if (localizacao.obra != null)
        {          
          this.obrasSelecionadas.push(localizacao.obra)
        }
      }
      this.filtrarOrdenarObrasSelecionadas()

    },
    limparSelecoes() {
      this.obraSelecionada = null
      this.obrasSelecionadas = []
      this.obrasSelecionadasFiltradas = []
      this.obrasSelecionadasFiltradasOrdenadas = []
      this.listarObrasSelecionadas = false
      this.filtrarOrdenarObrasSelecionadas()
    },
    toggleListarObrasSelecionadas() {
      this.listarObrasSelecionadas = !this.listarObrasSelecionadas;
    }
  }
})

const colunasExcluidas = ['localizacoes', 'codContrato', 'codLote', 'codProjeto']

function gerarToken(object: any): string {
  let concatenatedString = ''
  for (const key in object) {
    // Referência: https://eslint.org/docs/latest/rules/no-prototype-builtins
    const hasOwnPropertyKey = Object.prototype.hasOwnProperty.call(object, key)
    if (hasOwnPropertyKey) {
      if (object[key] != null && !colunasExcluidas.includes(key)) {
        const propertyValue = (object as any)[key]
        if (typeof propertyValue !== 'function') {
          concatenatedString += (propertyValue.toString() as string).toLowerCase() + '||'
        }
      }
    }
  }
  return concatenatedString
}

function isKeyOf<T>(value: keyof T, check: keyof T): boolean {
  return value === check
}

function getKeyOf<T>(instance: T, value: string): Extract<keyof T, string> | null {
  for (const key in instance) {
    if (key == value) return key
  }

  return null
}

function ordenar(element1: Obra, element2: Obra, ordenacaoCampo: string, ordenacaoDirecao: string) {
  if (ordenacaoCampo == '') return 0

  const valor1Key = getKeyOf(element1, ordenacaoCampo)
  const valor2Key = getKeyOf(element2, ordenacaoCampo)

  if (valor1Key == null || valor2Key == null) return 0

  let valor1: any = element1[valor1Key]
  let valor2: any = element2[valor2Key]
  const rglxp = /[&/\\#,+()$~%@^�'"!:*?<>\-/{}]/g

  if (isKeyOf(ordenacaoCampo, 'porcentagemExecutada')) {
    valor1 = Number(valor1.replaceAll('%', '').replaceAll('.', '').replaceAll(',', ''))
    valor2 = Number(valor2.replaceAll('%', '').replaceAll('.', '').replaceAll(',', ''))
  }

  if (isKeyOf(ordenacaoCampo, 'numProcesso')) {
    const ano1 = Number(valor1.split('/')[2])
    const ano2 = Number(valor2.split('/')[2])

    if (ano1 != ano2) {
      return ordenacaoDirecao == 'asc' ? ano1 - ano2 : ano2 - ano1
    }
  }

  if (isKeyOf(ordenacaoCampo, 'numContrato')) {
    if (valor1.toLowerCase() == 'sem contrato') valor1 = '0/0'
    if (valor2.toLowerCase() == 'sem contrato') valor2 = '0/0'

    const ano1 = Number(valor1.split('/')[1])
    const ano2 = Number(valor2.split('/')[1])

    if (ano1 != ano2) {
      return ordenacaoDirecao == 'asc' ? ano1 - ano2 : ano2 - ano1
    }
  }

  if (typeof valor1 === 'number') {
    return ordenacaoDirecao == 'asc' ? valor1 - valor2 : valor2 - valor1
  }

  if (typeof valor1 === 'string') {
    const text1 = valor1
      .toLowerCase()
      .replace(rglxp, '')
      .replace(/\s/g, '')
      .replace(/\n/g, '')

    const text2 = valor2
      .toLowerCase()
      .replace(rglxp, '')
      .replace(/\s/g, '')
      .replace(/\n/g, '')

    if (ordenacaoDirecao == 'asc') {
      return text1 < text2 ? -1 : text1 > text2 ? 1 : 0
    }

    if (ordenacaoDirecao == 'desc') {
      return text1 < text2 ? 1 : text1 > text2 ? -1 : 0
    }
  }

  return 0
}